import { render, staticRenderFns } from "./ActionSettings.vue?vue&type=template&id=a21f8fc4&"
import script from "./ActionSettings.vue?vue&type=script&lang=js&"
export * from "./ActionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports